import api from "./api";


export const deleteRole = async (id) => {
  const response = await api.delete(`/api/role/${id}`);
  return response.data;
};

export const getServiceById = async (id) => {
  const response = await api.get(`/api/services/${id}`);
  return response.data;
};

export const getAllServices = async () => {
  const response = await api.get(`/api/services`);
  return response.data;
};

export const addServices = async (payload) => {
  const response = await api.post(`/api/services`, payload);
  return response;
};

export const getRoleById = async (roleId) => {
  const response = await api.get(`/api/role/${roleId}`);
  return response.data;
};



export const createRole = async (payload) => {
   await api.post("/api/role", payload);
 // return response.data;
};

// Update an existing role
export const updateRole = async (roleId, payload) => {
   await api.put(`/api/role/${roleId}`, payload);
 // return response.data;
};

export const updateService = async (serviceId, payload) => {
   await api.put(`/api/services/${serviceId}`, payload);
 // return response.data;
};


// export const getServicesByRoleId = async (roleId) => {
//   const response = await api.get(`/api/role-service-mapping/role/${roleId}/services-status`);
//   return response.data;
// };



export   const getEmployeResignationByEmpId=async(employeeId)=>{
   const response = await api.get(`/api/employee-posting/employeeId/${employeeId}`);
    return response;
}